module.exports = "https://coursera_assets.s3.amazonaws.com/images/48a7c37e24e85b78e497c5667b2d7b56.png";